import { GetterTree } from 'vuex'
import { LangState } from './types'
import { RootState } from '../types'
import { localeToRegLocale } from '@/helpers/url'
import config from 'config'

export const getters: GetterTree<LangState, RootState> = {
  getLocale: (state: LangState) => state.locale,
  getCountry: (state: LangState) => state.locale.split('-')[1].toUpperCase(),
  getFallbackCountry: () => config.i18n.fallback_locale.split('-')[1].toUpperCase(),
  getLang: (state: LangState) => state.locale.split('-')[0],
  getRegLocale: (state: LangState) => localeToRegLocale(state.locale),
  getTranslations: (state: LangState) => state.translations
}
